import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import * as cs from '../../../Api/cs'

import useHeader from '../../../Helper/useHeader';


import Login from '../../../Pages/Login/Login'
import SignUp from '../../../Pages/SignUp/SignUp'
import OtpModal from '../../../Modal/OtpModal'

import { getLeaderboards } from '../../../Services/battles';

import './leaderboards.css';

const assignRanks = data => {
    // Clone and sort the data by winCount descending
    const sorted = [...data].sort((a, b) => b.winCount - a.winCount);
 
    let result = [];
    let rank = 1;
    let i = 0;


    while (i < sorted.length) {
        const currentWinCount = sorted[i].winCount;
        console.log('currentWinCount',currentWinCount)

        // Find how many have the same winCount
        const sameGroup = sorted.filter(item => item.winCount === currentWinCount);

        console.log('currentWinCount sameGroup',sameGroup)
        const count = sameGroup.length;

        // Compute the rank string
        const rankStr = count === 1 ? `${rank}` : `${rank}-${rank + count - 1}`;

        // Assign ranks to this group
        for (let j = 0; j < count; j++) {
            result.push({
                ...sameGroup[j],
                rank: rankStr
            });
        }

        // Skip to the next group
        i += count;
        rank += count;
        // Remove the processed group from the sorted array
        sorted.splice(0, count - 1);
    }

    return result;
}

const Leaderboards = () => {
    const navigate = useNavigate()
    const headers = useHeader();
    const { userId } = useSelector(state => {
        return state.user
    });

    const [user, setUser] = useState(null)
    const [showLogin, setShowLogin] = useState(false);
    const [showOtpModal, setShowOtpModel] = useState(false)
    const [showSignUp, setShowSignUp] = useState(false)
    const [showSetUp, setShowSetUp] = useState(false)
    const [id, setId] = useState(null)
    const [token2, setToken2] = useState(null)
    const [emailLinkModal, setEmailLinkModal] = useState(false)

    const [topPlayer, setTopPlayer] = useState(null);
    const [leaderboards, setLeaderboards] = useState([]);
    const [followLabel, setFollowLabel] = useState(`I'm a fan`);
    const [filter, setFilter] = useState('monthly')
    const [isLoading, setIsLoading] = useState(true);



    useEffect(() => {
        getLoaderboardsList('monthly');
    }, []);




    const getLoaderboardsList = async (filter) => {
        const now = moment();

        if (!isLoading) {
            setIsLoading(true);
        }
        const monthFilter = filter === 'monthly' ? {
            start: now.clone().startOf('month').format('YYYY-MM-DD'),
            end: now.clone().endOf('month').format('YYYY-MM-DD'),
        } : {};

        const response = await getLeaderboards(monthFilter, headers);


        if (response) {
           
            let leaderboardWithRanks = assignRanks(response);

             console.log('getLeaderboards leaderboardWithRanks',leaderboardWithRanks)

            const topLeaderBoard = { ...leaderboardWithRanks[0] };
            const otherLeaderBoard = [...leaderboardWithRanks];
            setTopPlayer(topLeaderBoard)
            setLeaderboards(otherLeaderBoard)
            getFollowingFollowers(topLeaderBoard?._id);
        }

        setIsLoading(false);

    }

    const getFollowingFollowers = async (id) => {
        const response = await cs.get('getfollowers/' + id + "/" + userId, 'follow', {}, headers)

        if (response?.data?.code === 200) {
            // setFollowingData(response?.data?.data)
            if (response?.data?.data?.fanStatus == 1) {
                setFollowLabel("Following")
            }
            else {
                setFollowLabel("I'm a fan")
            }

        }

    }


    const addFollower = async (id) => {
        if (userId == null) {
            setShowLogin(true)
        }
        else if (userId !== null) {
            const _data = {
                "followUser": id
            }
            await cs.post('add', 'follow', _data, headers)


            getFollowingFollowers(id)
        }


    }


    const handleLoginClose = () => {
        setShowLogin(false)
    }
    const handleOtpClose = () => {
        setShowOtpModel(false)
    }
    const handleSignUpClose = () => {
        setShowSignUp(false)
    }

    // const handleSetUpClose = () => {
    //     setShowSetUp(false)
    // }
    const handleEmailLinkClose = () => {
        setEmailLinkModal(false)
    }

    const handleFilterChange = type => () => {
        setFilter(type);
        getLoaderboardsList(type)
    }

    console.log('leaderboards', leaderboards)
    return (
        <div style={{ marginTop: 12 }}>
            <div className="leaderboard-title-container">
                <h3 style={{ color: 'white' }}>Top Contenders</h3>
            </div>


            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div onClick={handleFilterChange('monthly')} className={`leaderboard-filter ${filter === 'monthly' ? 'leaderboard-filter-selected' : ''}`}>MONTHLY</div>
                <div onClick={handleFilterChange('all-time')} className={`leaderboard-filter ${filter === 'all-time' ? 'leaderboard-filter-selected' : ''}`}>ALL TIME</div>
            </div>
            {!isLoading && leaderboards.length > 0 && <>

                <div className="leaderboard-main-container">
                    <div className="leaderboard-top-contender-container leaderboard-divider-container-1">
                        {topPlayer && <div className="leaderboard-top-contender-parent">
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: '0 0 50%' }}>
                                <div style={{ height: 250, paddingLeft: 5 }}>
                                    <img src={topPlayer.image} className="top-contender-image" />
                                    <div style={{
                                        width: 34,
                                        height: 34,
                                        color: 'white',
                                        backgroundColor: 'red',
                                        borderRadius: '50%',
                                        position: 'relative',
                                        bottom: '24px',
                                        zIndex: 5,
                                        top: -15,
                                        margin: '0 auto',
                                        textAlign: 'center',
                                        paddingTop: 5,
                                        backgroundColor: 'rgba(210, 172, 71, 1)'
                                    }}>1st
                                    </div>

                                </div>

                            </div>
                            <div style={{ paddingLeft: 24, flex: '0 0 50%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'space-between' }}>
                                <div style={{ paddingBottom: 15 }}>
                                    <div className="top-contender-title-text">TOP CONTENDER</div>
                                    <div style={{ color: 'rgba(255, 255, 255, 0.5)' }}>1st Place</div>
                                </div>
                                <div onClick={() => {
                                    navigate(`/profile/${topPlayer?.userId}`, { state: { type: "user", id: topPlayer?.userId } })
                                }}
                                    style={{ paddingTop: 15, paddingBottom: 15, cursor: 'pointer' }}>
                                    <div style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: 24, color: 'white' }}>{topPlayer.name}</div>
                                    <div style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: 13 }}>@{topPlayer.userName}</div>
                                </div>

                                <div style={{ paddingTop: 15, paddingBottom: 15 }}>
                                    <div style={{ color: 'rgba(255, 255, 255, 0.5)' }}>Battles Won: {topPlayer?.winCount}</div>
                                </div>

                                <div style={{ paddingTop: 15, paddingBoottom: 15 }}>
                                    <Button style={{ width: 126 }} variant='primary' onClick={() => {
                                        addFollower(topPlayer?.userId)
                                    }}>{followLabel}</Button>
                                </div>
                            </div>
                        </div>}

                    </div>

                    <div className="leaderboard-leader-container leaderboard-divider-container-2">
                        {leaderboards.map((item, index) => {
                            return <div onClick={() => {
                                navigate(`/profile/${item?.userId}`, { state: { type: "user", id: item?.userId } })
                            }} className="leaderboard-row" style={{ display: 'flex', flexDirection: 'row', paddingTop: 10, paddingBottom: 10, paddingLeft: 12, paddingRight: 12 }} key={index}>
                                <div style={{ flex: '0 0 20%' }}>{item.rank}</div>
                                <div style={{ flex: '0 0 60%' }}>
                                    <img style={{ width: 18, height: 18, borderRadius: '50%' }} src={item.image} />{`  `}
                                    <span style={{ paddingLeft: 12 }}>{item.name}</span>

                                </div>
                                <div style={{ flex: '0 0 20%' }}>{item.winCount} wins</div>

                            </div>
                        })}
                    </div>

                </div>

            </>}


            {showLogin && <Login showLogin={showLogin} handleLoginClose={handleLoginClose} setShowLogin={setShowLogin} setShowModel={setShowOtpModel} setEmailLinkModal={setEmailLinkModal} setShowSignUp={setShowSignUp} setUser={setUser} setShowSetUp={setShowSetUp} setId={setId} setToken2={setToken2} />}
            {showSignUp && <SignUp showSignUp={showSignUp} handleSignUpClose={handleSignUpClose} setShowSignUp={setShowSignUp} setShowLogin={setShowLogin} setShowModel={setShowOtpModel} setUser={setUser} user={user} setId={setId} setToken2={setToken2} />}
            {showOtpModal && <OtpModal showModal={showOtpModal} handleClose={handleOtpClose} setShowModel={setShowOtpModel} user={user} setShowLogin={setShowLogin} setShowSetUp={setShowSetUp} id={id} token2={token2} />}

        </div>
    )
}

export default Leaderboards